import { connect } from "react-redux";
import { Table, TableBody, TableCell, TableHead, TableRow, TablePagination } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/AvailableLeadsPage.css";

const mapStateToProps = (state) => {
    return {
        isFetching: state.data.isFetching,
    }
}

const LeadsTable = props => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const { isFetching } = props;
    const [ queryString ] = useState(window.location.search);
    const [ leads, setLeads ] = useState([]);
    const [ totalLeads, setTotalLeads ] = useState(0);
    const [ loading, setLoading ] = useState(false);

    const getBgColor = field => field ? '#A1FF99' : '#FF9999';

    const refresh = async () => {
        setLoading(true);
        const url = `/buffer/statistic/available-leads/details${queryString}&page=${page + 1}&limit=${rowsPerPage}`;
        const result = await axios.get(url)
            .then(({ data }) => data)
            .catch( e => {
                console.log(e);
                return [];
            });
        setLeads(result.leads);
        setTotalLeads(result.total);
        setLoading(false);
    }

    useEffect(async () => {
        await refresh();
    }, [ queryString, isFetching, page, rowsPerPage ]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div className={"al-page"} style={{margin:'2rem 4rem', overflow:'auto'}}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>From State</TableCell>
                        <TableCell>To State</TableCell>
                        <TableCell>Source</TableCell>
                        <TableCell>Serve Time</TableCell>
                        <TableCell>Callback Scheduled</TableCell>
                        <TableCell>Next Dial Time</TableCell>
                        <TableCell>Available Multi Transfer</TableCell>
                        <TableCell>Available By Rotation</TableCell>
                        <TableCell>Local Time</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        loading &&
                        <TableRow>
                            <TableCell colSpan={5}></TableCell>
                            <TableCell>Loading...</TableCell>
                            <TableCell colSpan={5}></TableCell>
                        </TableRow>
                    }
                    {
                        ! leads.length && ! loading &&
                        <TableRow>
                            <TableCell colSpan={5}></TableCell>
                            <TableCell>No data</TableCell>
                            <TableCell colSpan={5}></TableCell>
                        </TableRow>
                    }
                    {
                        ! loading && leads.map( lead => (
                            <TableRow key={lead.id}>
                                <TableCell>{lead.id}</TableCell>
                                <TableCell>{lead.from_state}</TableCell>
                                <TableCell>{lead.to_state}</TableCell>
                                <TableCell>{lead.source}</TableCell>
                                <TableCell bgcolor={getBgColor(lead.availability_qualifiers.serve_time.status)}>{String(lead.availability_qualifiers.serve_time.status)}</TableCell>
                                <TableCell bgcolor={getBgColor(lead.availability_qualifiers.callback_scheduled.status)}>{String(lead.availability_qualifiers.callback_scheduled.status)}</TableCell>
                                <TableCell bgcolor={getBgColor(lead.availability_qualifiers.next_dial_time.status)}>{String(lead.availability_qualifiers.next_dial_time.status)}</TableCell>
                                <TableCell bgcolor={getBgColor(lead.availability_qualifiers.available_multi_transfer.status)}>{String(lead.availability_qualifiers.available_multi_transfer.status)}</TableCell>
                                <TableCell bgcolor={getBgColor(lead.availability_qualifiers.available_by_rotation.status)}>{String(lead.availability_qualifiers.available_by_rotation.status)}</TableCell>
                                <TableCell bgcolor={getBgColor(lead.availability_qualifiers.local_time.status)}>{String(lead.availability_qualifiers.local_time.status)}</TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
            {
                totalLeads !== 0 && ! loading &&
                <TablePagination
                    component="div"
                    count={totalLeads}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            }
        </div>
    )
}

export default connect(mapStateToProps)(LeadsTable);
